/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".input_with_appended_unit[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{text-align:right;border:1px solid #ccc}.input_with_appended_unit[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{position:relative;top:2px}.formErrors[_ngcontent-%COMP%]{display:block;background:#fff;padding:15px 20px 15px 15px;margin:0 0 20px;position:relative;font-size:80%;line-height:1.2;text-align:justify;color:red;font-weight:700;border-left:4px solid red;border-right:4px solid red;box-shadow:2px 2px 15px #ccc}"];
export { styles as styles };
